import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from 'vue'
import { footerState } from '../../stores/footer'


export default /*@__PURE__*/_defineComponent({
  __name: 'NotFound',
  setup(__props) {

onMounted(() => {
  footerState.setFooterDefault()
})

return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createBlock(_component_v_alert, {
    value: true,
    type: "warning",
    class: "not-found-screen"
  }, {
    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createTextVNode(" 404!!! ページがない又はページアクセスの権限がありません。 ", -1 /* CACHED */)
    ]))]),
    _: 1 /* STABLE */
  }))
}
}

})